const checkbox = "_checkbox_1t5jj_57";
const disabled = "_disabled_1t5jj_71";
const styles = {
  checkbox,
  disabled
};
export {
  checkbox,
  styles as default,
  disabled
};
//# sourceMappingURL=Checkbox.module.scss.js.map
